import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = { class: "container flex gap-2 justify-between max-w-5xl mx-auto p-5 pb-3 xl:flex-row" }
const _hoisted_4 = { class: "flex gap-2 items-center" }
const _hoisted_5 = { class: "h1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "1",
    y1: "9.29289",
    x2: "5.29289",
    y2: "5",
    stroke: "#222B45",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5.29289",
    y1: "5",
    x2: "1",
    y2: "0.707107",
    stroke: "#222B45",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "h1" }, "Tables", -1)
const _hoisted_8 = { class: "container flex gap-2 justify-between max-w-5xl mx-auto px-5 py-3" }
const _hoisted_9 = { class: "flex gap-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "0.707107",
    x2: "0.707106",
    y2: "5",
    stroke: "#222B45",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "0.707107",
    y1: "5",
    x2: "5",
    y2: "9.29289",
    stroke: "#222B45",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Back", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "+ Add Table Category", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "+ Add Table", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "flex gap-2" }
const _hoisted_18 = { class: "container flex flex-col gap-2 max-w-5xl mx-auto p-5" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"box-head justify-between\"><div class=\"flex gap-4 items-center\"><div class=\"w-14\"></div><div class=\"w-32\"><span class=\"text-order\">Name</span></div><div class=\"flex justify-center w-20\"><span class=\"text-order\">Serving</span></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_treeitem = _resolveComponent("treeitem")!
  const _component_tableCategory = _resolveComponent("tableCategory")!
  const _component_table_add = _resolveComponent("table_add")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Store.Name), 1),
          _hoisted_6,
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "button-back cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/store/${_ctx.$route.params.id}`)))
          }, _hoisted_12),
          _createElementVNode("div", {
            class: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAddCategory && _ctx.toggleAddCategory(...args)))
          }, _hoisted_14),
          _createElementVNode("div", {
            class: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleAddTable && _ctx.toggleAddTable(...args)))
          }, _hoisted_16)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_AutoComplete, {
            "track-by": "Value",
            "filter-by": "Value",
            "show-by": "Value",
            items: [
                        { Id: 'true', Value: 'Serving' },
                        { Id: 'false', Value: 'Not Serving' }
                    ],
            modelValue: _ctx.selectedTableFilter,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTableFilter) = $event)),
            placeholder: "Serving",
            onSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateData('table')))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode(_component_treeitem, {
          labels: _ctx.Categories,
          onLoadNode: _ctx.getChildren
        }, null, 8, ["labels", "onLoadNode"])
      ])
    ]),
    (_ctx.addCategory)
      ? (_openBlock(), _createBlock(_component_tableCategory, {
          key: 0,
          modelValue: _ctx.SaveCategoryMode,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.SaveCategoryMode) = $event)),
          onSubmit: _ctx.pushTable,
          onClose: _ctx.toggleAddCategory,
          items: _ctx.SaveCategory
        }, null, 8, ["modelValue", "onSubmit", "onClose", "items"]))
      : _createCommentVNode("", true),
    (_ctx.addTable)
      ? (_openBlock(), _createBlock(_component_table_add, {
          key: 1,
          modelValue: _ctx.SaveCategoryMode,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.SaveCategoryMode) = $event)),
          id: _ctx.id,
          onClose: _ctx.toggleAddTable,
          categories: _ctx.Categories
        }, null, 8, ["modelValue", "id", "onClose", "categories"]))
      : _createCommentVNode("", true)
  ]))
}